const configuredBase = import.meta.env.VITE_API_BASE || '/api';
const API_BASE = configuredBase.replace(/\/$/, '');

let csrfToken = null;

export class ApiError extends Error {
  constructor(message, status, errors = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.errors = errors;
  }
}

export function setCsrfToken(token) {
  csrfToken = token || null;
}

export async function apiRequest(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const requestUrl = `${API_BASE}${path}`;
  const fetchUrl = import.meta.env.DEV && ['GET', 'HEAD'].includes(method)
    ? `${requestUrl}${requestUrl.includes('?') ? '&' : '?'}_dev=${Date.now()}`
    : requestUrl;
  const headers = new Headers(options.headers || {});
  const isFormData = options.body instanceof FormData;

  if (options.body && !isFormData && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  if (!['GET', 'HEAD'].includes(method) && csrfToken) {
    headers.set('X-CSRF-Token', csrfToken);
  }

  const response = await fetch(fetchUrl, {
    ...options,
    method,
    headers,
    credentials: 'include',
    cache: 'no-store',
  });

  const responseText = await response.text();
  let payload = null;

  if (responseText.trim() !== '') {
    try {
      payload = JSON.parse(responseText);
    } catch {
      payload = null;
    }
  }

  if (payload === null && response.status !== 204) {
    const contentType = response.headers.get('content-type') || 'missing content-type';
    const responsePreview = responseText.replace(/\s+/g, ' ').trim().slice(0, 120);
    const diagnostic = `${method} ${requestUrl} returned HTTP ${response.status} (${contentType})`;

    console.error('API returned a non-JSON response.', {
      method,
      requestUrl,
      fetchUrl,
      responseUrl: response.url,
      status: response.status,
      contentType,
      responsePreview,
    });

    throw new ApiError(
      `${diagnostic}. Response begins: ${responsePreview || '[empty response]'}`,
      response.ok ? 502 : response.status,
    );
  }
  if (!response.ok || payload?.success === false) {
    throw new ApiError(payload?.message || `Request failed with status ${response.status}.`, response.status, payload?.errors);
  }

  return payload?.data ?? {};
}

export async function initializeSession() {
  const data = await apiRequest('/auth/me.php');
  setCsrfToken(data.csrfToken);
  return data.user;
}
